import React from "react";
import { NavLink } from "react-router-dom";

export default function NavBar() {
  return (
    <div className="nav-bar-container">
      <nav>
        <NavLink className="home-nav-link" to="/my-work">
          My Work
        </NavLink>
        <NavLink className="home-nav-link" to="/who-i-am">
          {" "}
          Who I am
        </NavLink>
        <a
          href="jonah-tillman-resume.pdf"
          className="resume"
          download={"jonah-tillman-resume"}
        >
          Resume ⇣
        </a>
      </nav>
    </div>
  );
}
